/* eslint-disable @typescript-eslint/no-explicit-any */
interface ckoVerificationStatusReturn {
    isBankVerificationFailed: boolean,
    isKYCVerificationFailed: boolean
}

export const getAthleteCkoVerificationStatus = (user: any): ckoVerificationStatusReturn => {
    const ckoSubEntityDdStatusReason = user?.ckoSubEntityDdStatusReason ? JSON.parse(
        user?.ckoSubEntityDdStatusReason
    ) : "";
    const isRequirementsDue: boolean = ["requirements_due"].includes(
        user?.ckoSubEntityDdStatus || ''
    );

    // useEffect(() => {
    let isBankVerificationFailed = false;
    let isKYCVerificationFailed = false;
    if (
        ckoSubEntityDdStatusReason &&
        Array.isArray(ckoSubEntityDdStatusReason)
    ) {
        isBankVerificationFailed = ckoSubEntityDdStatusReason.some(
            (item: any) => {
                return item?.field.includes("bank_verification");
            }
        );
        isKYCVerificationFailed = ckoSubEntityDdStatusReason.some((item: any) => {
            return item?.field.includes("identity_verification");
        });
    }
    return {
        isBankVerificationFailed: isRequirementsDue && isBankVerificationFailed,
        isKYCVerificationFailed: isRequirementsDue && isKYCVerificationFailed,
    }
}


const personalFields = [
    'first_name',
    'last_name',
    'dob',
    'phone',
    'email',
    'address.line1',
    'address.line2',
    'address.city',
    'address.state',
    'address.postal_code',
    'id_number',
    'verification.document',
    'verification.document.front',
    'verification.document.back',
];

const bankFields = [
    'external_account',
    'external_account_verification.document',
    'documents.bank_account_ownership_verification.files',
];

// Payment Requirement
export interface PaymentRequirementsStatus {
    hasBankFieldsDue: boolean;
    hasProfileFieldsDue: boolean;
    status: 'personal_missing' | 'bank_missing' | 'both_missing' | 'complete' | 'verification_pending';
}

export const getPaymentRequirementsStatus = (user: any): PaymentRequirementsStatus => {
    const parsedRequirements = user?.paymentRequirements
        ? JSON.parse(user.paymentRequirements)
        : null;

    const pendingVerification = parsedRequirements?.pending_verification || [];

    const combinedRequirements: string[] = [
        ...(parsedRequirements?.currently_due || []),
        // ...(parsedRequirements?.pending_verification || []), // Uncomment if needed
    ];

    const individualPersonalFields = personalFields.map((pf) => `individual.${pf}`);

    const hasBankFieldsDue = combinedRequirements.some((field) =>
        bankFields.includes(field)
    );

    const hasProfileFieldsDue = combinedRequirements.some(
        (field) =>
            individualPersonalFields.includes(field) ||
            field.startsWith('individual.verification.')
    );

    // Determine overall status
    let status: PaymentRequirementsStatus['status'];
    if (pendingVerification.length > 0) status = 'verification_pending';
    else if (hasBankFieldsDue && hasProfileFieldsDue) status = 'both_missing';
    else if (hasProfileFieldsDue) status = 'personal_missing';
    else if (hasBankFieldsDue) status = 'bank_missing';
    else status = 'complete';

    return {
        hasBankFieldsDue,
        hasProfileFieldsDue,
        status,
    };
};

